<template>
  <a-modal
    :title="title"
    :visible="visible"
    :confirm-loading="confirmLoading"
    @ok="handleOk"
    :width="800"
    @cancel="handleCancel"
  >
    <a-form :form="form" :label-col="{ span: 5 }" :wrapper-col="{ span: 17 }">
      <a-form-item label="本次发布时间">
        <a-date-picker
          placeholder="请输入本次发布时间"
          style="width: 100%"
          :disabled="type === '3'"
          v-decorator="[
            'publishDate',
            {
              initialValue: rowConetent.publishDate,
              rules: [{ required: true, message: '请输入本次发布时间' }]
            }
          ]"
        />
      </a-form-item>
      <a-form-item label="本次发布版本">
        <a-input
          placeholder="请输入本次发布版本"
          :disabled="type === '3'"
          v-decorator="[
            'version',
            {
              initialValue: rowConetent.version,
              rules: [{ required: true, message: '请输入本次发布版本' }]
            }
          ]"
        />
      </a-form-item>
      <a-form-item label="本次发布内容">
        <div v-if="type === '3'" class="constent-text">
          <div v-html="rowConetent.content"></div>
        </div>
        <template v-else>
          <text-edit
            v-if="visible"
            :content="contentHtml"
            :first="isFirst"
            v-decorator="[
              'content',
              {
                initialValue: rowConetent.content,
                rules: [{ required: true, message: '请输入本次发布内容' }]
              }
            ]"
            @inputValue="() => changeText()"
            @onblur="(value) => changeValue(value)"
          ></text-edit>
        </template>
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import { PublishRecordServiceProxy } from '@/service-proxies/app-v2/system.service-proxies'
const prsp = new PublishRecordServiceProxy()
import TextEdit from './TextEdit.vue'
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: '1'
    },
    rowConetent: {
      type: Object,
      default: () => ({})
    }
  },
  components: {
    TextEdit
  },
  computed: {
    title() {
      let name = ''
      switch (this.type) {
        case '1':
          name = '新建'
          break
        case '2':
          name = '编辑'
          break
        case '3':
          name = '发布'
          break
        default:
          name = '提示'
          break
      }
      return name
    }
  },
  watch: {
    type: {
      handler() {
        if (this.rowConetent && this.rowConetent.content) {
          this.contentHtml = this.rowConetent.content
        } else {
          this.contentHtml = ''
        }
        this.isFirst = true
      },
      deep: true,
      immediate: true
    }
  },
  data() {
    return {
      form: this.$form.createForm(this),
      confirmLoading: false,
      contentHtml: '',
      isFirst: true
    }
  },
  methods: {
    changeText() {
      this.isFirst = false
    },
    changeValue(value) {
      this.form.setFieldsValue({ content: value })
    },
    handleOk() {
      switch (this.type) {
        case '1':
          this.submit()
          break
        case '2':
          this.updated()
          break
        case '3':
          this.updated()
          break
        default:
          break
      }
    },
    submit() {
      this.form.validateFields((err, values) => {
        if (!err) {
          this.confirmLoading = true
          prsp
            .submit(values)
            .then(() => {
              this.$message.success('保存成功')
              this.confirmLoading = false
              this.form.resetFields()
              this.contentHtml = ''
              this.$emit('cancel', true)
            })
            .catch(() => {
              this.confirmLoading = false
            })
        }
      })
    },
    updated() {
      this.form.validateFields((err, values) => {
        if (!err) {
          values.id = this.rowConetent.id
          if (this.type === '3') {
            values.publishStatus = 1
          } else {
            values.publishStatus = this.rowConetent.publishStatus
          }
          this.confirmLoading = true
          prsp
            .updateRecord(values)
            .then(() => {
              if (this.type != '3') {
                this.$message.success('保存成功')
              } else {
                this.$message.success('发布成功')
              }
              this.confirmLoading = false
              this.form.resetFields()
              this.contentHtml = ''
              this.$emit('cancel', true)
            })
            .catch(() => {
              this.confirmLoading = false
            })
        }
      })
    },
    handleCancel() {
      this.$emit('cancel', false)
      this.form.resetFields()
      this.contentHtml = ''
    }
  }
}
</script>

<style lang="less" scoped>
.constent-text {
  border: 1px solid #d8d8d8;
  padding: 8px;
  color: rgba(0, 0, 0, 0.25);
  background-color: #f5f5f5;
  cursor: not-allowed;
  opacity: 1;
}
</style>
